import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const allCarPlateNumber = createApi({
  reducerPath: "allCarPlateNumber",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    
    getAllCarsPlateNumber: builder.query({
      query: () => ({
        url: "/Car/all-cars-for-operation",
        method: "GET",
      }),
    }),
 
    getAllCars: builder.query({
      query: () => ({
        url: "/Car/all-cars",
        method: "GET",
      }),
    }),
  }),
});

export const { 
  useGetAllCarsPlateNumberQuery,
  useGetAllCarsQuery
} = allCarPlateNumber;
